module.exports = __webpack_public_path__ + "img/softgrove-7.c044bb53.jpeg";